import React from 'react';
import PropTypes from 'prop-types';
// styles
import { TextFieldStyled } from '../../styles';

export const EmailInputComponent = React.forwardRef(({
  value,
  onChange,
  onBlur,
  onClick,
  error,
  errorMessage,
  placeholder,
}, ref) => (
  <TextFieldStyled
    id='suspect-email-capture-form-email-input'
    label='Email'
    ref={ref}
    name='email'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={onBlur}
    onClick={onClick}
    required={true}
    maxLength={200}
    placeholder={placeholder} />
));

EmailInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default EmailInputComponent;
